"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitesStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class SitesStore {
    constructor() {
        this.submission = {};
        this.parsedSites = {};
        this.submitted = false;
        this.parsed = false;
        this.parsedRows = []; // #TK the parsed import file as an array of arrays
        this.importedSites = [];
        this.selectedRowIndex = 0;
        this.importColumnsHeader = [
            // for testing default
            "this",
            "list",
            "is",
            "for",
            "testing",
            "site",
            "import"
        ];
        this.import = async (files) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newSite", file, file.name);
            });
            let response = await api_1.SiteEndpoint.parse.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            response = await api_1.SiteEndpoint.submit.apiCall(null, {
                sites: response.sites
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.parse = async (files) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newSite", file, file.name);
            });
            const response = await api_1.SiteEndpoint.parse.apiCall(null, formData);
            try {
                if (response.sites) {
                    this.parsedSites = {
                        sites: response.sites
                    };
                }
            }
            catch (e) {
                console.log("an error caught from parse: ", e);
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.parsed = true;
            }
        };
        this.parseRow = async (files) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newSite", file, file.name);
            });
            const response = await api_1.SiteEndpoint.parserow.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.parsedRows = response.parsedRows;
                this.parsed = true;
            }
        };
        this.submit = async (sites) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const response = await api_1.SiteEndpoint.submit.apiCall(null, {
                sites
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
    }
}
__decorate([
    mobx_1.observable
], SitesStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "parsedSites", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "parsed", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "siteHeaders", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "importedSites", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "dbHeaders", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "providers", void 0);
__decorate([
    mobx_1.observable
], SitesStore.prototype, "importColumnsHeader", void 0);
__decorate([
    mobx_1.action
], SitesStore.prototype, "import", void 0);
__decorate([
    mobx_1.action
], SitesStore.prototype, "parse", void 0);
__decorate([
    mobx_1.action
], SitesStore.prototype, "parseRow", void 0);
__decorate([
    mobx_1.action
], SitesStore.prototype, "submit", void 0);
exports.sitesStore = new SitesStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/store.ts
// module id = 2465
// module chunks = 0